import React from 'react';
import { Drawer } from '@dsg-tech/homefield-react';
import { HomefieldIconSignCancel } from '@dsg-tech/homefield-react-icons';
import { KEY_CODES } from 'utility/constants';
import SignedOutState from './SignedOutState/SignedOutState';
import './MyAccountDrawer.scss';

interface MyAccountDrawerProps {
  headerRef: React.RefObject<HTMLElement> | null;
  showDrawer: boolean;
  setShowDrawer: () => void;
  closing: boolean;
  viewPortBreakpoint: string;
}

const MyAccountDrawer = ({
  headerRef,
  showDrawer,
  setShowDrawer,
  closing,
  viewPortBreakpoint,
}: MyAccountDrawerProps) => {
  return (
    <Drawer
      className="myaccount-drawer-container"
      anchorElement={viewPortBreakpoint === 'mobile' ? null : headerRef?.current}
      attachedBackground={viewPortBreakpoint !== 'mobile'}
      open={showDrawer}
      closing={closing}
      // This prop has been removed from the type definition of the Drawer, but it still gets passed
      // to the underlying Modal component. This was removed to ensure that all Drawers would be
      // accessible by making sure they could always be closed, but this wassn't a problem for us
      // since we were already including alternate ways of closing the Drawer. The Homefield team is
      // working on a way that would allow for better ways to customize the closing button, but for
      // the time being we're just ignoring this and relying on undocumented behavior
      // ~Blair Wilcox 7/30/2025
      //
      // eslint-disable-next-line
      // @ts-ignore
      closable={false}
      onCloseModal={() => setShowDrawer()}
      direction={viewPortBreakpoint === 'mobile' ? 'bottom' : 'right'}>
      <div className="my-account-drawer-content-container">
        <div className="my-account-drawer-header hmf-display-flex hmf-flex-row hmf-justify-content-between hmf-pt-m hmf-pb-xs hmf-px-m hmf-align-items-center">
          <span className="hmf-header-bold-s">My Account</span>
          <button
            className="close-icon-container hmf-p-xxs"
            type="button"
            aria-label="Close menu"
            onClick={() => setShowDrawer()}
            onKeyDown={(event) => {
              if (event.key === KEY_CODES.SPACE || event.key === KEY_CODES.ENTER) {
                setShowDrawer();
              }
            }}
            tabIndex={0}>
            <HomefieldIconSignCancel width="24" height="24" />
          </button>
        </div>
        <div className="my-account-drawer-body">
          <SignedOutState />
        </div>
      </div>
    </Drawer>
  );
};

export default MyAccountDrawer;
